import React from 'react';
import { Heart, Bookmark, Share2 } from 'lucide-react';
import maffick from "./img/maffick.png";
import aryan_saxena from "./img_sc/aryan_saxena.jpeg";
import raghvendra_singh from "./img_sc/raghvendra_singh.jpeg";
import kummari_siddharth from "./img_sc/kummari_siddharth.jpg";
import ayush_singh from './img_sc/ayush_singh.jpeg';
import aryan_baghel from './img_sc/aryan_sing_baghel.jpeg';
import shikhar_vijay from './img_sc/shikhar_vijay.jpeg';
import punit_kumar from './img_sc/punit_kumar.png';
import alen_joseph from './img_sc/alen_joseph.jpeg';
import harsh_rathore from './img_sc/harsh_rathore.jpeg';
import aditya_chauhan from './img_sc/aditya_chauhan.jpg';
import anish_pandit from './img_sc/anish_pandit.jpg';
import vaidik from './img_sc/vaidik_singh.jpeg';
import discipline from './img_sc/discipline_sec.jpeg';
import naman_sharma from './img_sc/naman_sharma.jpeg';
import raj_chouhan from './img_sc/raj_chouhan.jpeg';
import aryan_patel from './img_sc/aryan_patel.jpeg';
import ankit from './img_sc/ankit_kumar_pandey.jpeg';

const ImageCard = ({ imageSrc, title, description }) => {
  return (
    <div className="relative rounded-lg overflow-hidden shadow-sm group cursor-pointer transform transition-transform hover:scale-105" style={{width:"100%"}}>
      <div className="aspect-[3/4] w-full relative max-w-[10rem]"> {/* Added aspect-[3/4] back */}
        <img 
          src={imageSrc} 
          alt={title}
          className="w-full h-full object-cover"
        />
        <div className="relative inset-0 bg-gradient-to-t from-black/80 via-black/20 to-transparent" />
        
        <div className="relative bottom-0 left-0 right-0 p-1.5 text-white">
          <h3 className="text-sm font-bold mb-0.5">
            {title}
          </h3>
          <p className="text-xs text-gray-200 mb-1.5 line-clamp-2">
            {description}
          </p>
          
          <div className="flex gap-1">
            <button className="w-2.5 h-2.5 rounded-full bg-white/20 backdrop-blur-sm flex items-center justify-center hover:bg-white/30 transition-colors">
              <Heart className="w-1 h-1" />
            </button>
            <button className="w-2.5 h-2.5 rounded-full bg-white/20 backdrop-blur-sm flex items-center justify-center hover:bg-white/30 transition-colors">
              <Bookmark className="w-2 h-2" />
            </button>
            <button className="w-2.5 h-2.5 rounded-full bg-white/20 backdrop-blur-sm flex items-center justify-center hover:bg-white/30 transition-colors">
              <Share2 className="w-1 h-1" />
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

const App = () => {
  const cards = [
    { title: "Ayush Singh", description: "President (Fourth Year, UG)", imageSrc:ayush_singh },
{ title: "Raj Chouhan", description: "Vice-President (Fourth Year, UG)", imageSrc:raj_chouhan },
{ title: "Naman Sharma", description: "Secretary Cultural (Fourth Year, UG)", imageSrc:naman_sharma },
{ title: "Raghvendra Singh Gaur", description: "Secretary Technical (Fourth Year, UG)", imageSrc: raghvendra_singh },
{ title: "Vaidik Singh Parihar", description: "Secretary (sports) (Fourth Year, UG)", imageSrc: vaidik },
{ title: "G. Lakshmi Sri Rama", description: "Secretary Discipline (Fourth Year, UG)", imageSrc: discipline },
{ title: "K. Siddharth", description: "Secretary Media (Fourth Year,UG)", imageSrc: kummari_siddharth },
{ title: "Aryan Saxena", description: "General Secretary (Third Year, UG)", imageSrc: aryan_saxena },
{ title: "Punit Kumar", description: "Treasurer (Third Year, UG)", imageSrc: punit_kumar },
{ title: "Aryan Singh Baghel", description: "Secretary Alumni (Third Year, UG)", imageSrc: aryan_baghel },
{ title: "Aditya Chauhan", description: "Joint-Secretary (Second Year,UG)", imageSrc: aditya_chauhan },
{ title: "Anish Pandit", description: "Secretary (Literary, Hindi) (Second Year, UG)", imageSrc: anish_pandit },
{ title: "Aryan Patel", description: "Secretary(Literacy,English) (Second Year, UG)", imageSrc: aryan_patel },
{ title: "Harsh Rathore", description: "Executive Member, UG (1st Yr)", imageSrc: harsh_rathore },
{ title: "Alen Joseph", description: "Executive Member, UG (1st Yr)", imageSrc: alen_joseph },
{ title: "Shikhar Viyay", description: "Executive Member, MCA/MBA/B.TECH+M.TECH", imageSrc: shikhar_vijay },
{ title: "Ambuj Kumar Dwivedi", description: "Executive Member (M.Tech/M.Plan/M.Arch)", imageSrc: maffick },
{ title: "Ankit Kumar Pandey", description: "Executive Member, MA/MSc", imageSrc: ankit },
{ title: "Virag Bohare", description: "Executive Member, Ph.D", imageSrc: maffick },
{ title: "Vaibhav Goyal", description: "Ex-Member (Ex-Officio)", imageSrc: maffick }

  ];

  return (
    <div className="relative inset-0 bg-gradient-to-br from-#0f0f23-900 via-#1a1a2e-900/80 via-#16213e-900 to-#0f3460-900/90 overflow-auto p-4"> {/* Full viewport cover */}
      <div className="max-w-6xl mx-auto h-full flex flex-col justify-center"> {/* Centered content */}
        <h1 className="text-2xl font-bold text-white mb-4 text-center" style={{paddingTop:"15vh"}}>
          OUR TEAM
        </h1>
        
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-2 flex-1" style={{paddingLeft:"8vw"}}> {/* 4 cols on lg+ */}
          {cards.map((card, index) => (
            <ImageCard
              key={index}
              imageSrc={card.imageSrc}
              title={card.title}
              description={card.description}
            />
          ))}
        </div>
      </div>
    </div>
  );
};

export default App;
